import { Route } from '@angular/router';
import { Path } from '../../../common/constants/paths.constant';
import { receivedRfpDetailsResolver } from '../../../common/resolvers/received-rfp.resolver';
import { quotationRFPDetailsResolver } from '../../../common/resolvers/quotation-rfp-details.resolver';
import { poRFPDetailsResolver } from '../../../common/resolvers/po-rfp-details.resolver';

export const contractorRoutes: Route[] = [
  {
    path: '',
    redirectTo: `/${localStorage.getItem('lang') ?? 'ar'}/${Path.CONTRACTOR}/${Path.DASHBOARD}`,
    pathMatch: 'full',
  },
  {
    path: Path.DASHBOARD,
    loadComponent: () =>
      import('./dashboard/dashboard.component').then(c => c.DashboardComponent),
  },
  {
    path: Path.RECEIVED_RFP.RECEIVED_RFP,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./received-rfp/received-rfp-board.component').then(
            c => c.ReceivedRfpBoardComponent
          ),
      },
      {
        path: `${Path.RECEIVED_RFP.DETAILS}/:rfpId`,
        loadComponent: () =>
          import('./received-rfp/received-rfp-details/received-rfp-details.component').then(
            c => c.ReceivedRfpDetailsComponent
          ),
        resolve: {
          rfpDetails: receivedRfpDetailsResolver,
        },
      },
    ],
  },
  {
    path: Path.QUOTATION.QUOTATION_RFP,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../../../pages/dashboard/contractor/quotations/quotations.component').then(
            C => C.QuotationsComponent
          ),
      },
      {
        path: `${Path.QUOTATION.DETAILS}/:rfpId/:quotationId`,
        loadComponent: () =>
          import('../../../pages/dashboard/contractor/quotations/quotation-details-view/quotation-details-view.component').then(
            c => c.QuotationDetailsViewComponent
          ),
        resolve: {
          data: quotationRFPDetailsResolver,
        },
      },
    ],
  },
  {
    path: Path.PO.PO_RFP,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./purchased-order/purchased-order-board.component').then(
            c => c.PurchasedOrderBoardComponent
          ),
      },
      {
        path: `${Path.PO.DETAILS}/:id`,
        loadComponent: () =>
          import('./purchased-order/purchased-order-details/purchased-order-details.component').then(
            c => c.PurchasedOrderDetailsComponent
          ),
        resolve: {
          poDetails: poRFPDetailsResolver,
        },
      },
    ],
  },
  {
    path: Path.ACCOUNT,
    loadComponent: () =>
      import('./account/account.component').then(c => c.AccountComponent),
  },
  {
    path: Path.MY_SERVICES,
    loadComponent: () =>
      import('./my-services/my-services.component').then(
        c => c.MyServicesComponent
      ),
  },
];
